import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { FeaturedArticles } from '../components/FeaturedArticles';
import { CategorySection } from '../components/CategorySection';
import { TrustSection } from '../components/TrustSection';
import { Newsletter } from '../components/Newsletter';
export function HomePage() {
  return <>
      <HeroSection data-id="element-431" />
      <FeaturedArticles limit={3} showViewAll={true} data-id="element-432" />
      <CategorySection data-id="element-433" />
      <TrustSection data-id="element-434" />
      <Newsletter data-id="element-435" />
    </>;
}